import React, { useState, useEffect } from "react"
import axios from "axios"
import { useNavigate, useParams } from "react-router-dom"
import { FaBars, FaAngleLeft } from 'react-icons/fa'
import Form from 'react-bootstrap/Form'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import { apiURL, sitePath } from 'config/globals'
import Topbar from 'components/Topbar'
import Sidebar from 'components/Sidebar'
import Breadcrumbs from 'components/Breadcrumbs'
import FormRow from 'components/FormRow'
import CancelButton from 'components/CancelButton'
import SaveButton from 'components/SaveButton'
import Footer from 'components/Footer'
import { checkAuth, authForm, logout, isSuperAdmin } from 'utils/Auth'

const UserEdit = () => {
    const [currentUser, setCurrentUser] = useState(false)
    const [dbUser, setDbUser] = useState({})
    const [form, setForm] = useState({})
    const [loadError, setLoadError] = useState('')
    const [submitError, setSubmitError] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false)
    const navigate = useNavigate()
    const { id } = useParams()
    
    useEffect(() => {
        const start = async () => {
            const user = await checkAuth(navigate)
            setCurrentUser(user)
        }
        start()
    }, [])

    useEffect(() => {
        const getUser = async () => {
            await getDbUser(id)
        }
        getUser()
    }, [currentUser])

    const getDbUser = async (id) => {
        if (!currentUser) {
            return
        }

        const response = await axios.get(`${apiURL}/get-db-user/${id}`)
        
        if (!response.data.success) {
            setLoadError("Cannot load user data: " + (response.data.error || response.data))
            return
        }

        if (response.data.item.id != currentUser.id && !isSuperAdmin(currentUser)) {
            setLoadError("You don´t have the required permissions to change this pasword")
            return
        }

        setDbUser(response.data.item)
    }

    const handleChange = (field, value) => {
        setForm({
            ...form,
            [field]: value
        })
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        event.stopPropagation()

        setSubmitError("")


        setIsSubmitting(true)

        try {
            const requestUrl = `${apiURL}/update-password/${dbUser.id}`
            const response = await axios.put(requestUrl, authForm(form))

            if (!response.data.success) {
                setSubmitError(response.data.error || response.data)
                setIsSubmitting(false)
                return
            }

            logout(navigate)
        } catch (error) {
            setSubmitError(JSON.stringify(error))
            setIsSubmitting(false)
        }
    }

    const cancel = () => {
        navigate(`/users/${dbUser.id}`)
    }

    const back = () => {
        navigate(`/users`)
    }

    return (
        <>
            <Topbar currentUser={currentUser} />
            <Sidebar selectedItem="users" currentUser={currentUser} />
            <main>
                <Breadcrumbs items={[['Users', '/users'], [dbUser.name, `/users/${dbUser.id}`], ['Change Password']]} />
                <div className="btn-toggle">
                    <FaBars />
                </div>
                <header>
                    <div className="float-start">
                        <h1>Change Password</h1>
                    </div>
                </header>
                {currentUser.id && dbUser.id &&
                    <>
                        <FormRow
                            id="oldPassword"
                            label="Old Password"
                            required={true}
                            content={
                                <Form.Control
                                    name="oldPassword"
                                    type="password"
                                    autoComplete="off"
                                    onChange={e => handleChange(e.target.name, e.target.value)}
                                />
                            }
                        />
                        <FormRow
                            id="newPassword1"
                            label="New Password"
                            required={true}
                            content={
                                <Form.Control
                                    name="newPassword1"
                                    type="password"
                                    autoComplete="off"
                                    onChange={e => handleChange(e.target.name, e.target.value)}
                                />
                            }
                        />
                        <FormRow
                            id="newPassword2"
                            label="New Password (repeat)"
                            required={true}
                            content={
                                <Form.Control
                                    name="newPassword2"
                                    type="password"
                                    autoComplete="off"
                                    onChange={e => handleChange(e.target.name, e.target.value)}
                                />
                            }
                        />
                        {submitError && 
                            <Alert key='submitError' variant='danger' className="mt-4">
                                {submitError}
                            </Alert>
                        }
                        <div className="mt-5 mb-4 d-grid d-lg-block">
                            <SaveButton isSubmitting={isSubmitting} onClick={handleSubmit} title="Save" />
                        </div>
                    </>
                }
                {loadError &&
                    <>
                        <Alert key='loadError' variant='danger'>
                            {loadError}
                        </Alert>
                        <div className="mt-5 mb-4 d-grid d-lg-block">
                            <Button variant="outline-primary" size="lg" className="mb-3" onClick={back}>
                                <FaAngleLeft /> Back
                            </Button>
                        </div>
                    </>
                }
                <Footer user={currentUser} />
            </main>
        </>
    )
}

export default UserEdit